import React from 'react';
import PropTypes from 'prop-types';
import { values, pick } from 'lodash-es';
import RadioButtonGroup from '../RadioButtonGroup';
import StoreIcon from '../StoreIcon';

const OPTIONS = {
  unified: {
    id: 'unified',
    value: 'unified',
    text: <div className="d-flex"><StoreIcon store="unified" />Both Stores</div>,
  },
  itunes_connect: {
    id: 'itunes_connect',
    value: 'itunes_connect',
    text: <div className="d-flex"><StoreIcon store="itunes_connect" />iOS</div>,
  },
  google_play: {
    id: 'google_play',
    value: 'google_play',
    text: <div className="d-flex"><StoreIcon store="google_play" />Google Play</div>,
  },
};

const StoreSelection = ({ active, onChange, currentStore }) => {
  const availableOptions = () => {
    let options = OPTIONS;
    if (currentStore === 'itunes_connect' || currentStore === 'google_play') {
      options = pick(OPTIONS, ['unified', currentStore]);
    }

    return values(options);
  };

  return (
    <div className="d-flex flex-row add-to-market-modal-store-selection">
      <div className="m-r-sm d-flex align-items-end"><span>Choose app entity type:</span></div>
      <RadioButtonGroup
        options={availableOptions()}
        active={active}
        onChange={onChange}
        name="app-store-selection"
        enabled
      />
    </div>
  );
};

StoreSelection.propTypes = {
  active: PropTypes.string,
  currentStore: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

StoreSelection.defaultProps = {
  active: '',
  currentStore: 'unified',
};

export default StoreSelection;
